module.exports = __webpack_public_path__ + "static/media/expressjs.62f84be9.png";